import { ref, computed } from '@vue/composition-api';

class ReactiveMap<K, V> extends Map<K, V> {
  constructor(private readonly onMutate: () => void, map?: Map<K, V>) {
    // @ts-expect-error For some reason TypeScript does not like it
    super(map);
  }

  set(key: K, value: V) {
    super.set(key, value);
    this.onMutate();
    return this;
  }

  delete(key: K): boolean {
    const res = super.delete(key);
    this.onMutate();
    return res;
  }
}

export default function useReactiveMap<K, V>() {
  const version = ref(1);

  function onMutate() {
    version.value += 1;
  }

  const inner = ref(new ReactiveMap<K, V>(onMutate));

  const set = computed<Map<K, V>>({
    get: () => {
      // eslint-disable-next-line no-unused-expressions
      version.value;
      return inner.value;
    },
    set: (map: Map<K, V>) => {
      inner.value = new ReactiveMap(onMutate, map);
      version.value += 1;
    },
  });

  return set;
}
